<template>
  <v-expansion-panels outlined flat :value="panel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-selection" color="#D1DCEA">
        <template>
          <div @click="handleHeaderClick" class="container-resumo">
            <div>
              <p>DATA DE PGTO</p>
              <p class="font-weight-bold">{{ lote.dataPagamento | formatDate}}</p>
            </div>
            <div class="justify-center" >
              <p class="font-weight-bold">{{ lote.operadoraAns.nome }}</p>
              <p>{{ lote.prestador.nome }}</p>
            </div>
            <div>
              <p>Nº Lote</p>
              <p class="font-weight-bold">{{ lote.numeroLote || '-' }}</p>
            </div>
            <div>
              <p>PROTOCOLO</p>
              <p class="font-weight-bold">{{ lote.numeroProtocolo }}</p>
            </div>
            <div>
              <p>STATUS</p>
              <p class="font-weight-bold">{{ pagamentoLoteStatusLabel }}</p>
            </div>
            <div>
              <p>RESPONSÁVEL</p>
              <p class="font-weight-bold">{{ responsavelLote }}</p>
            </div>
            <div>
              <p>TOTAL INFORMADO</p>
              <p class="font-weight-bold">R$ {{ lote.valorInformado | formatPrice }}</p>
            </div>
          </div>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content :style="'border: 1px solid #D5D5D5; border-bottom-left-radius: inherit; border-bottom-right-radius: inherit'">
        <div class="colapse-container">
          <DetalhamentoValoresPagamentoLote
            :valorInformado="lote.valorInformadoCalculado"
            :valorPago="lote.valorPago"
            :valorGlosado="lote.valorGlosado"
          />
          <div class="conciliacao-bars pl-8">
            <table>
              <thead>
                <tr>
                  <th>Conciliação</th>
                </tr>
              </thead>
              <tbody>
                <tr class="first-row">
                  <td>
                    <PercentBarGroup
                      :progressBars="conciliacaoValores"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <PercentBarGroup
                      :progressBars="conciliacaoItems"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="lote.nenhumaGuiaEncontrada">
            <v-chip>Nenhuma guia encontrada</v-chip>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import DetalhamentoValoresPagamentoLote from './DetalhamentoValoresPagamentoLote.vue'
import PercentBarGroup from '../../common/PercentBarGroup'
import { pagamentoLoteStatusLabels } from '@tradimus/api-conciliacao-client'
import { getItemPercentMessages, getValorPercentMessages } from '../../../libs'

export default {
  components: {
    DetalhamentoValoresPagamentoLote,
    PercentBarGroup
  },
  props: {
    lote: Object,
    isStatusCliente: Boolean
  },
  data() {
    return {
      pagamentoLoteStatusLabels,
      panel: 0
    }
  },
  computed: {
    valoresConciliacaoTexts () {
      return getValorPercentMessages(
        this.lote.valorPago + this.lote.valorGlosado,
        this.lote.valorItensConciliacaoAutomatica,
        this.lote.valorItensConciliacaoManual
      )
    },
    itensConciliacaoTexts () {
      return getItemPercentMessages(
        this.lote.quantidadeItens,
        this.lote.quantidadeItensConciliacaoAutomatica,
        this.lote.quantidadeItensConciliacaoManual
      )
    },
    conciliacaoItems () {
      return [
        {
          label: 'Itens',
          total: this.lote.percentualConciliadoQuantidade,
          automatica: this.lote.percentualConciliadoQuantidadeAutomatico,
          manual: this.lote.percentualConciliadoQuantidadeManual,
          textAutomatica: this.itensConciliacaoTexts.textAutomatica,
          textManual: this.itensConciliacaoTexts.textManual,
          textRestante: this.itensConciliacaoTexts.textRestante
        }
      ]
    },
    conciliacaoValores () {
      return [
        {
          label: 'Valor',
          total: this.lote.percentualConciliadoValor,
          automatica: this.lote.percentualConciliadoValorAutomatico,
          manual: this.lote.percentualConciliadoValorManual,
          textAutomatica: this.valoresConciliacaoTexts.textAutomatica,
          textManual: this.valoresConciliacaoTexts.textManual,
          textRestante: this.valoresConciliacaoTexts.textRestante
        }
      ]
    },
    isUsuarioTradimus () {
      const isUsuarioTradimus = JSON.parse(sessionStorage.getItem('userData'))
      return isUsuarioTradimus.UsuarioTradimus
    },
    pagamentoLoteStatusLabel () {
      if (this.isUsuarioTradimus || (!this.isUsuarioTradimus && this.isStatusCliente)){
        return this.pagamentoLoteStatusLabels[this.lote.status]
      } else {
        return 'Em processamento Tradimus'
      }
    },
    responsavelLote () {
      if(this.isStatusCliente && !this.isUsuarioTradimus || !this.isStatusCliente && this.isUsuarioTradimus) {
        return this.lote.responsavel == null ? '-' : this.lote.responsavel.nome
      } else if (!this.isStatusCliente && !this.isUsuarioTradimus) {
        return 'Tradimus'
      } else {
        return 'Cliente'
      }
    }
  },
  methods: {
    handleHeaderClick (event) {
      if (window?.getSelection()?.toString()) {
        event.stopPropagation()
        return
      }
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 8px;
}
table, td, th {
  border: 1px solid white;
}
table {
  font-weight: 700;
  width: 100%;
}
thead {
  width: 100%;
}
td {
  padding: 4px 16px 4px 0;
}
.first-row td, tr{
  border-bottom: 1px solid #D1DCEA;
}
.container-resumo {
  display: flex;
  justify-content: space-between;
  padding-right: 24px;
}
.colapse-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 24px;
}
.conciliacao-bars {
  width: 30%;
}

.text-selection {
  user-select: text;
}
</style>
